import React, { useState } from 'react';
import ManageRoomComponent from './ManageRoomComponent';
import Loader from '../Common/Loader';

const ManageRoomContainer = ({ match, history }) => {
  const [notice, setNotice] = useState({ type: '', message: '' });
  const [loaderStatus, setLoaderStatus] = useState(false);

  const setNoticeMessage = (errorMessage, errorType) => {
    setNotice({
      type: errorType,
      message: errorMessage
    });
    
    // Clear notice after 3 seconds
    setTimeout(() => {
      setNotice({ type: '', message: '' });
    }, 3000);
  };

  const setUILoaderVisibility = (status) => {
    setLoaderStatus(status);
  };

  return (
    <React.Fragment>
      {loaderStatus && <Loader />}
      <div
        className={`alert_col posfixed pad10 tc fnt16 bld ${
          notice.type === 'error' ? 'danger' : 'success'
        } ${notice.message === '' ? 'hides' : ''}`}
      >
        <div dangerouslySetInnerHTML={{ __html: notice.message }} />
      </div>
      <ManageRoomComponent
        room_category_id={match?.params?.room_category_id || 0}
        history={history}
        setNoticeMessage={setNoticeMessage}
        setUILoaderVisibility={setUILoaderVisibility}
      />
    </React.Fragment>
  );
};

export default ManageRoomContainer;
